import React from 'react';
import { useTranslation } from 'react-i18next';
import { useUserGroupsMenu } from '@modules/userGroups/hooks/useUserGroupsMenu';

const UserGroupsMenu = ({ onClose, onSave, groupData }) => {
    const { t } = useTranslation();
    const {
        modalRef,
        selectedMenus,
        menus,
        isAllSelected,
        handleCheckboxChange,
        handleSelectAll,
        handleSubmit,
        handleClickOutside
    } = useUserGroupsMenu({ onClose, onSave, groupData });

    return (
        <div className='modal show' tabIndex="-1" onMouseDown={handleClickOutside}>
            <div className="form-menus">
                <form className="form" ref={modalRef} onSubmit={handleSubmit}>
                    <div className="form-header">
                        <h2 className='title'>{t('nav.administrator.permissions.accessMenus')}</h2>
                    </div>

                    <div className="form-menus-input-wrapper">
                        <div className='form-input-fields'>
                            <div className="input-checkbox-wrapper">
                                <input
                                    type="checkbox"
                                    id="selectAll"
                                    checked={isAllSelected}
                                    onChange={handleSelectAll}
                                />
                                <label htmlFor="selectAll">{t('nav.administrator.permissions.accessAll')}</label>
                            </div>

                            {menus.map((item) => (
                                console.log(item, "item"),
                                <div key={item.id} className="input-checkbox-wrapper">
                                    <input
                                        type="checkbox"
                                        id={item.id}
                                        value={item.id}
                                        name='specRights'
                                        checked={selectedMenus.some(menu => menu.id === item.id)}
                                        onChange={handleCheckboxChange}
                                    />
                                    <label htmlFor={item.id.toString()}>
                                        {t(`nav.administrator.permissions.${item.code}`) || item.specialRightCategory?.name || item.code}
                                    </label>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="form-controls-container padding-20">
                        <button type="submit" className="form-btn btn-blue">
                            {t('common.save')}
                        </button>
                        <button
                            type="button"
                            className="form-btn btn-red"
                            onClick={onClose}
                            style={{ marginRight: '10px' }}
                        >
                            {t('common.cancel')}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default UserGroupsMenu; 